// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  FormatElapsedTime,
  FormatEpochToFullTimestamp,
} from 'components/DataTable/Formatters'

import { FormatAnalysisStatus } from './Formatters'

const columns = [{
  columnHeader: 'Project',
  columnKey: 'projectName',
  sortable: true,
}, {
  columnHeader: 'Band GHz',
  columnKey: 'band',
  // columnWidth: '70px',
  sortable: true,
}, {
  columnHeader: 'Analysis',
  columnKey: 'analysisType',
  sortable: true,
}, {
  cellFormatter: FormatAnalysisStatus,
  columnHeader: 'Status',
  columnKey: 'analysisStatus',
  sortable: true,
}, {
  cellFormatter: FormatEpochToFullTimestamp,
  columnHeader: 'Submitted',
  columnKey: 'submitTime',
  sortable: true,
}, {
  cellFormatter: FormatEpochToFullTimestamp,
  columnHeader: 'Start Time',
  columnKey: 'startTime',
  sortable: true,
}, {
  cellFormatter: FormatElapsedTime,
  columnHeader: 'Elapsed Time',
  columnKey: 'elapsedTime',
  // columnWidth: '90px',
}, {
  cellFormatter: FormatEpochToFullTimestamp,
  columnHeader: 'End Time',
  columnKey: 'endTime',
  sortable: true,
}]

export default columns
